{
	"actions": {
		"bulk_revoke": "Revoca tutti di questo creatore",
		"cancel": "Annulla",
		"open_menu": "Apri azioni",
		"revoke": "Revoca"
	},
	"bulk_revoke": {
		"confirm": "Revoca tutti",
		"description": "Ogni link attivo creato da questa persona smette di funzionare immediatamente. L'azione non può essere annullata.",
		"done_one": "Revocato {{count}} link.",
		"done_other": "Revocati {{count}} link.",
		"none": "Questa persona non ha link attivi.",
		"pending": "Revoca in corso…",
		"title": "Revocare tutti i link creati da {{name}}?"
	},
	"columns": {
		"access_count": "Aperture",
		"creator": "Creato da",
		"expiry": "Scadenza",
		"kind": "Tipo",
		"password": "Password",
		"resource": "Risorsa",
		"state": "Stato"
	},
	"creator": {
		"unknown": "Membro rimosso"
	},
	"empty": {
		"description": "Nessun membro della tua organizzazione ha ancora creato un link pubblico.",
		"disabled_description": "I link pubblici sono disattivati per questa organizzazione. Attivali in Policy per permettere ai membri di crearne uno.",
		"disabled_title": "I link sono disattivati",
		"no_matches_description": "Prova un filtro diverso.",
		"no_matches_title": "Nessun link corrisponde a questi filtri",
		"title": "Nessun link attivo"
	},
	"filters": {
		"creator": "Creatore",
		"creator_placeholder": "Cerca per nome o email",
		"expires_within_days": "In scadenza entro",
		"expires_within_days_option_one": "{{count}} giorno",
		"expires_within_days_option_other": "{{count}} giorni",
		"has_password": "Password",
		"state": "Stato"
	},
	"kind": {
		"download": "Condivisione",
		"upload": "Link di caricamento"
	},
	"kind_filter": {
		"all": "Tutti",
		"download": "Condivisione",
		"upload": "Link di caricamento"
	},
	"page_title": "Link attivi",
	"password": {
		"no": "Nessuna password",
		"yes": "Protetto da password"
	},
	"refusal": {
		"not_found": "Questo link non esiste più. Aggiorna l'elenco."
	},
	"revoke": {
		"confirm": "Revoca",
		"description": "Il link smette di funzionare immediatamente. L'azione non può essere annullata.",
		"done": "Link revocato.",
		"pending": "Revoca in corso…",
		"title": "Revocare il link su \"{{name}}\"?"
	},
	"state": {
		"active": "Attivo",
		"expired": "Scaduto",
		"policy_blocked": "Bloccato da policy",
		"revoked": "Revocato"
	},
	"state_helper": {
		"policy_blocked": "Riprende automaticamente se la policy dell'organizzazione riattiva i link."
	},
	"view": {
		"all": "Tutti",
		"expired": "Scaduti",
		"live": "Attivi",
		"revoked": "Revocati"
	}
}
